import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ContentfulLayoutZoneBlockContent } from 'src/app/core/interfaces/Contentful/LayoutZone/ContentfulLayoutZoneContent';

@Component({
  selector: 'app-contentful-content-details-block',
  templateUrl: './contentful-content-details-block.component.html',
  styleUrls: ['./contentful-content-details-block.component.scss'],
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppContentfulContentDetailsBlockComponent {
  @Input() contentfulCategory?: ContentfulLayoutZoneBlockContent;
}
